import { HeroIconType } from "@utils/utils";
import { IconType } from "react-icons/lib";
import { MdAdminPanelSettings } from "react-icons/md";
import { PiMedalBold, PiStarFill } from "react-icons/pi";
import { RiLetterSpacing2 } from "react-icons/ri";

import { convertReadableString } from "@components/forms/utils";

export const FALLBACK_ICON = PiStarFill;

// Source name on a QA suggestion card.
export const QUALITY_REVIEW_SOURCE = "Quality Review";

export const getSuggestionIcon = (
  category: string,
): { Icon: HeroIconType | IconType; iconClassName: string; label: string } => {
  // Categories arrive in two shapes:
  //   - legacy enum-style (e.g. "DOCUMENT_COMPLETENESS") — only meaningful after convertReadableString
  //   - human-readable from QA Packages (e.g. "Document Completeness", "CCS QA") — already display-ready
  // Only run the snake_case→Title-Case transform for the legacy shape so we
  // don't mangle the readable casing on new package-derived categories
  // (preserves "CCS QA" instead of lowercasing it to "Ccs qa").
  const displayLabel = category.includes("_") ? convertReadableString(category) : category;
  const matchKey = displayLabel.toLowerCase();
  switch (matchKey) {
    case "document completeness":
      return {
        Icon: RiLetterSpacing2,
        iconClassName: "bg-yellow-500",
        label: "Document Completeness",
      };
    case "goals":
    case "goal integrity":
      return {
        Icon: PiMedalBold,
        iconClassName: "bg-green-600",
        label: "Goal Quality",
      };
    case "insurance standards":
      return {
        Icon: MdAdminPanelSettings,
        iconClassName: "bg-globemallow-500",
        label: "Insurance Standards",
      };
    default:
      return {
        Icon: FALLBACK_ICON,
        iconClassName: " bg-blurple-500",
        label: displayLabel,
      };
  }
};
